<template>
  <div id="app">
      <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="fullPage"
        :color="'#007bff'"
        :loader="loader"></loading>
      <nav-menu></nav-menu>
      <router-view></router-view>
  </div>
</template>

<script>
import NavMenu from './components/nav_menu';
import 'bulma';
import 'es6-promise/auto';
import { mapState } from 'vuex'   //Vuex が提供する mapState 関数を使う
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import { INTERNAL_SERVER_ERROR, UNAUTHORIXED, BAD_REAUEST } from './util.js'
export default {
  name: 'app',
  components: {
    'nav-menu': NavMenu,
    Loading
  },
  data: function(){
    return {
      modal: {
        fullPage: true
      },
    }
  },
  computed: {
    ...mapState({
      errorCode: state => state.error.code,
      errorMessage: state => state.error.message,
      apiStatus: state => state.auth.apiStatus,
      isLoading: state =>  state.loading.isLoading,
      loader: state => state.loading.loader,
    }),
  },
  watch: {
    errorCode: {
      handler (val) {
        if(val === UNAUTHORIXED) {
          this.$swal({
            title: 'ログインの有効期限切れ',
            text: '再度ログインを行ってください。',
            icon: "warning",
            allowOutsideClick: false,
          })
          .then((willDelete) => {
            if (willDelete) {
              this.hasTokenReload()
            }
          })
        }else if(val === BAD_REAUEST){
          this.$swal({
            title: 'エラー',
            html: this.errorMessage,
            icon: "error",
            allowOutsideClick: false,
          })
        }else if(val){
          this.$swal({
            title: '不明なエラー',
            html: '<div>不明なエラーが発生しました。</div><div>管理者へご連絡ください。</div><div>Error Code: ' + val + '</div>',
            icon: "warning",
            allowOutsideClick: false,
          })
          .then((willDelete) => {
            if (willDelete) {
              this.hasTokenReload()
            }
          })
        }
      },
      immediate: true
    },
    $route() {
      this.$store.commit('error/setCode', null)
      this.$store.commit('loading/setLoadingStatus', { loading: false, message: '' } )
    },
  },
  methods:{
    async hasTokenReload(){
      await this.$store.dispatch('auth/logout')
      if(this.apiStatus){
        this.$router.go({ path: this.$router.currentRoute.path, force: true})
      }
    },
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

@media print{
  .no_print{
      display: none;
  }
}
.tooltip {
  display: block !important;
  z-index: 10000;
}
.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}
.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}
.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}
.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}
.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}
.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}
.tooltip[x-placement^="right"] {
  margin-left: 5px;
}
.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}
.tooltip[x-placement^="left"] {
  margin-right: 5px;
}
.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}
.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, .1);
}
.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}
.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}
.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}
</style>
